module.exports = __webpack_public_path__ + "media/src/assets/Images/Home-2c985d9c544afeaa0d9c605512326f97.svg";